import React from 'react';
import Image from 'next/image';
import HeadLogo from '$/components/HeadLogo';
import IconFont from '$/components/IconFont';
import { getEnv } from '@/common/agents';
import appStoreBadge from '@/components/overseaHome/layout/footer/images/app-store.svg';
import googlePlayBadge from '@/components/overseaHome/layout/footer/images/google-play.svg';
import seoLogo from './seologo.png';
import styles from './index.module.scss';

const APP_STORE_DOWNLOAD_URL = 'https://roboneo-global.go.link/gQmVn';
const GOOGLE_PLAY_DOWNLOAD_URL = 'https://roboneo-global.go.link/9471I';

/**
 * SEO 页脚，集中展示品牌信息、应用下载入口及站点导航。
 */
export default function SeoFooter() {
  const goLandingpage = (url: string) => {
    const { origin } = window.location;
    const pathName = url;
    // 检查 url 是否已经是完整的 HTTP/HTTPS 链接
    let fullUrl;
    if (url.startsWith('http://') || url.startsWith('https://')) {
      fullUrl = url;
    } else {
      fullUrl = `${origin}/${(getEnv().ENV === 'development') ? `--roboneo/${pathName}` : pathName}`;
    }
    window.open(fullUrl);
  };
  const renderModel = (title: string, modals: Array<{ label: string;url: string; }>) => {
    return (
      <div className={styles['modal-container']}>
        <div className={styles['modal-title']}>{title}</div>
        <div className={styles['modal-items']}>
          {modals.map((item) => (
            <div
              key={item.label}
              onClick={(url) => { goLandingpage(item.url); }}
              className={styles['modal-link-item']}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className={styles['footer-container']}>
      <div className={styles['footer-left']}>
        <HeadLogo headerLogo={seoLogo} />
        <div className={styles['site-desc']}>AI Creative Agent</div>
        <div className={styles['icon-container']}>
          <div
            className={styles['icon-circle']}
            onClick={() => {
              window.location.href = 'mailto:support@roboneo.com';
            }}
          >
            <IconFont name="mailbox" color="var(--seo-content-primary, rgba(250, 252, 255, 0.90))" fontSize={20} />
          </div>
          <div
            className={styles['icon-circle']}
            onClick={() => {
              window.open('https://x.com/RoboNeo_ai');
            }}
          >
            <IconFont name="x" color="var(--seo-content-primary, rgba(250, 252, 255, 0.90))" fontSize={20} />
          </div>
          <div
            className={styles['icon-circle']}
            onClick={() => {
              window.open('https://discord.com/invite/JXt2gwDpVp');
            }}
          >
            <IconFont name="discord" color="var(--seo-content-primary, rgba(250, 252, 255, 0.90))" fontSize={20} />
          </div>
        </div>
        {/* 两个应用商店入口分别跳转对应渠道的下载落地页。 */}
        <div className={styles['download-container']}>
          <a href={APP_STORE_DOWNLOAD_URL} aria-label="Download RoboNeo on the App Store" target="_blank" rel="noopener noreferrer">
            <Image src={appStoreBadge} alt="Download on the App Store" width={88} height={30} />
          </a>
          <a href={GOOGLE_PLAY_DOWNLOAD_URL} aria-label="Get RoboNeo on Google Play" target="_blank" rel="noopener noreferrer">
            <Image src={googlePlayBadge} alt="Get it on Google Play" width={88} height={30} />
          </a>
        </div>
      </div>
      {renderModel('Image Models', [
        { label: 'Gemini 3.1', url: 'https://www.roboneo.com/gemini-3-0-image-video-understanding' },
        { label: 'Flux Knotext', url: 'https://www.roboneo.com/flux-kontext-image-editing' },
      ])}
      {renderModel('Video Models', [
        { label: 'Seedance 2.0', url: 'https://www.roboneo.com/seedance2' },
        { label: 'Kling 3.0', url: 'https://www.roboneo.com/kling-3' },
        { label: 'Sora 2', url: 'https://www.roboneo.com/roboneo-sora2-video-generator' },
        { label: 'VEO 3.0', url: 'https://www.roboneo.com/veo3-video-generator' },
        { label: 'Wan 2.6', url: 'https://www.roboneo.com/wan-video-generator2' },
      ])}
      {renderModel(
        'Help & Legal',
        [{ label: 'Terms of Service', url: 'https://www.roboneo.com/user-agreement?countryCode=en&theme=dark' },
          { label: 'Privacy Policy', url: 'https://www.roboneo.com/privacy-policy?countryCode=en&theme=dark' },
          { label: 'Help Center', url: 'https://www.notion.so/cpp-roboneo/RoboNeo-Playbook-2a024b73201880ef886afdeb4864b7d0' },
        ],
      )}
    </div>
  );
}
